import axios from 'axios';

const remove = async (groupId: string) => {
  const { data } = await axios.delete(`/group/${groupId}`);
  return data;
};

export default remove;
